module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Movie-lane1-e604fcc12e1952c29129a42458af7f68.svg";